import { formatPrice } from 'utils/helpers';
/**
 * Final Price is a number typed in the event form ($ field): shown as money,
 * blank (the "-" placeholder) when not set.
 */
export const formatOptionalPrice = (value?: number | string | null) =>
  value === null || value === undefined || value === ''
    ? undefined
    : formatPrice(value);
